// extracted by mini-css-extract-plugin
module.exports = {"TextEdit__toolbar":"TextEdit__toolbar__2okCR","TextEdit__output":"TextEdit__output__1QdT-"};